import { Link, Stack, Typography } from '@mui/material';

import { links } from '@/localization';

import { ChainsAnimationContainer } from '../../Overview/styled';
import EmptyStateContainer from '../../sections/EmptyStateContainer';
import { EmptyStateButton } from '../../sections/EmptyStateContainer/EmptyStateButton';
import BasetenIcon from '../../sections/EmptyStateContainer/icons/BasetenIcon';
import DocsIcon from '../../sections/EmptyStateContainer/icons/DocsIcon';

function EmptyState() {
  return (
    <EmptyStateContainer>
      <Stack alignItems="center" maxWidth={600} gap={4}>
        <ChainsAnimationContainer />
        <Stack gap={2}>
          <Typography variant="h3" textAlign="center">
            You haven&apos;t deployed any Chains yet
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            Chains enable you to build complex AI systems by composing models, business logic, and
            external APIs into multi-step workflows.{' '}
            <Link href={links.basetenDocsChainsOverview} target="_blank">
              Learn more
            </Link>
          </Typography>
        </Stack>
        <Stack gap={2} maxWidth={430} width="100%">
          <Typography variant="h5" textAlign="center">
            Try one of these to get started, or{' '}
            <Link href={links.basetenDocsChainsYourFirstChain} target="_blank">
              deploy your own
            </Link>
            .
          </Typography>
          <EmptyStateButton
            href={links.basetenDocsChainsExampleTranscribe}
            icon={<DocsIcon />}
            target="_blank"
          >
            Transcribe audio with Chains
          </EmptyStateButton>
          <EmptyStateButton
            href={links.basetenDocsChainsExampleRAG}
            icon={<DocsIcon />}
            target="_blank"
          >
            RAG pipeline with Chains
          </EmptyStateButton>
          <EmptyStateButton
            href={links.basetenDocsChainsOverview}
            target="_blank"
            icon={<BasetenIcon />}
          >
            Learn more in docs
          </EmptyStateButton>
        </Stack>
      </Stack>
    </EmptyStateContainer>
  );
}

export { EmptyState };
